import gsap from "gsap";

export function initAddToHomescreen() {
  const scene = document.getElementById("btn-homescreen");
  if (!scene) return;
  const btn = scene.querySelector(".btn-homescreen");

  gsap.to(btn, {
    x: 0,
    duration: 0.5,
    delay: 1,
    ease: "power2.out",
  });
}

export function initHeroTilt() {
  let layers = document.getElementById("hero_background");
  //let scene_wrap = document.getElementById("hero_background_wrap");
  let scene = document.getElementById("hero");

  if (!scene) return false;

  gsap.fromTo(layers, { opacity: 0 }, { opacity: 1, ease: "power2.out", delay: 0.4 });

  scene.addEventListener(
    "mousemove",
    function (event) {
      event.stopPropagation();

      let cx = window.innerWidth / 2;
      let cy = window.innerHeight / 2;

      let dx = event.x - cx;
      let dy = event.y - cy;

      let tiltx = dy / cy;
      let tilty = -(dx / cx);

      gsap.set(layers, {
        transformOrigin: "center",
        transformPerspective: 1500,
      });

      gsap.to(layers, {
        rotationX: tiltx * -3,
        rotationY: tilty * -3,
        duration: 1,
      });
    },
    false
  );
}
